import React, { useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import EditableParam from './EditableParam';
import { matchesSearch } from './UserAttributeSection';

type Props<M> = {
  bank: M;
  onChange: (bank: M) => void;
  // shows only the fields (coins / diamonds) matching it
  search?: string;
};

export default function PiggyEditor({ bank, onChange, search = '' }: Props<{ coins: string; diamonds: string }>) {
  const { coins, diamonds } = useMemo(
    () => ({
      coins: bank.coins,
      diamonds: bank.diamonds,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // @ts-ignore
  const handleChangeBank = (key: string) => (event) => {
    const { value } = event.target;
    if (onChange) {
      onChange({ ...bank, [key]: value });
    }
  };

  if (!bank) return null;

  const fields = [
    { key: 'coins' as const, placeholder: coins },
    { key: 'diamonds' as const, placeholder: diamonds },
  ].filter(({ key }) => matchesSearch(key, search));

  return (
    <Card>
      <Card.Body>
        {fields.length > 0 ? (
          fields.map(({ key, placeholder }) => (
            <EditableParam
              key={key}
              title={key}
              value={bank[key]}
              onChange={handleChangeBank(key)}
              placeholder={placeholder}
            />
          ))
        ) : (
          <i>No match</i>
        )}
      </Card.Body>
    </Card>
  );
}
